/**
 * Created by anatolij on 29.09.2026
 */

const RoyalLeagueLogic = function (mission) {
    cleverapps.EventEmitter.call(this);

    this.mission = mission;

    const details = mission.details || {};
    this.claimed = details.claimed || 0;
    this.joined = details.joined || Date.now();
    this.shownTier = details.shownTier || 0;

    if (mission.isRunning()) {
        mission.logEvent(Mission.EVENTS.MISSION_STAGE, { itemId: `${this.getReachedStages()}`, once: true });
    }
};

RoyalLeagueLogic.prototype = Object.create(cleverapps.EventEmitter.prototype);
RoyalLeagueLogic.prototype.constructor = RoyalLeagueLogic;

RoyalLeagueLogic.prototype.save = function (details) {
    details.claimed = this.claimed;
    details.joined = this.joined;
    details.shownTier = this.shownTier;
};

RoyalLeagueLogic.prototype.getFinishWindow = function () {
    return RoyalLeagueWindow;
};

RoyalLeagueLogic.prototype.getCompetitionOptions = function () {
    return {
        ...Missions[Mission.TYPE_ROYAL_LEAGUE].competition,
        start: this.joined
    };
};

RoyalLeagueLogic.prototype.earnPoints = function (value) {
    const reached = this.getReachedStages();

    this.mission.logEvent(Mission.EVENTS.MISSION_POINTS, { value });
    this.mission.logEvent(Mission.EVENTS.MISSION_POINTS_DAU, { once: true });

    this.mission.update(value);

    for (let stage = reached + 1; stage <= this.getReachedStages(); stage++) {
        this.mission.logEvent(Mission.EVENTS.MISSION_STAGE, { itemId: `${stage}` });
    }
};

RoyalLeagueLogic.prototype.onComplete = function () {
    if (this.mission.getSummary().place === 0) {
        this.mission.logEvent(Mission.EVENTS.MISSION_FINISH, { once: true });
    }
};

RoyalLeagueLogic.prototype.getCurrentLevel = function () {
    return RoyalLeagueLevelsAdapter.getCurrentLevel(this.mission);
};

RoyalLeagueLogic.prototype.onUpdateMission = function (value) {
    if (value > 0 && typeof Game !== "undefined" && Game.currentGame) {
        this.pendingDelta = (this.pendingDelta || 0) + value;
    }

    this.trigger("updateResult", value);
};

RoyalLeagueLogic.prototype.receiveRewards = function (f) {
    const value = this.pendingDelta;
    delete this.pendingDelta;

    this.mission.receiveIncome(value, f);
};

RoyalLeagueLogic.prototype.getTier = function () {
    return RoyalLeagueLogic.CalcTier(this.mission.result);
};

RoyalLeagueLogic.prototype.hasNewTier = function () {
    return this.getTier() > this.shownTier;
};

RoyalLeagueLogic.prototype.markTierShown = function () {
    this.shownTier = this.getTier();
    this.mission.onChanged();
};

RoyalLeagueLogic.prototype.getTierName = function () {
    return RoyalLeagueLogic.TIER_NAMES[this.getTier()];
};

RoyalLeagueLogic.prototype.getSideBarSkin = function () {
    return this.getTierName();
};

RoyalLeagueLogic.prototype.getLevelTitle = function () {
    return Messages.get("RoyalLeague.PlayButton.text", { round: RoyalLeagueLevelsAdapter.getRound(this.mission) + 1 });
};

RoyalLeagueLogic.prototype.getCrownIcon = function () {
    return bundles.tournament_icon.frames[`royal_league_crown_${this.getTierName()}`];
};

RoyalLeagueLogic.prototype.getIncomeIcon = function () {
    return this.getCrownIcon();
};

RoyalLeagueLogic.prototype.getStages = function () {
    return this.mission.stages;
};

RoyalLeagueLogic.prototype.getReachedStages = function () {
    return this.getStages().filter((stage) => this.mission.result >= stage.points).length;
};

RoyalLeagueLogic.prototype.isLastStage = function (index) {
    return index === this.getStages().length - 1;
};

RoyalLeagueLogic.prototype.getCurrentStageIndex = function () {
    return Math.min(this.getReachedStages(), this.getStages().length - 1);
};

RoyalLeagueLogic.prototype.getCurrentStage = function () {
    const stages = this.getStages();
    const index = this.getCurrentStageIndex();
    const start = index > 0 ? stages[index - 1].points : 0;

    return {
        prize: stages[index].prize,
        goal: stages[index].points - start,
        progress: Math.min(this.mission.result, stages[index].points) - start
    };
};

RoyalLeagueLogic.prototype.getStageReward = function (index) {
    return new RewardsList(this.getStages()[index].prize, { event: this.mission.name });
};

RoyalLeagueLogic.prototype.isStageClaimed = function (index) {
    return index < this.claimed;
};

RoyalLeagueLogic.prototype.isStagesCompleted = function () {
    return this.getReachedStages() === this.getStages().length;
};

RoyalLeagueLogic.prototype.hasUnclaimedStages = function () {
    return this.claimed < this.getReachedStages();
};

RoyalLeagueLogic.prototype.claimStages = function () {
    if (!this.hasUnclaimedStages()) {
        return undefined;
    }

    const stages = this.getStages().slice(this.claimed, this.getReachedStages());

    stages.forEach((stage, index) => {
        this.mission.logEvent(Mission.EVENTS.MISSION_REWARD_VALUE, { reward: stage.prize, itemId: `stage${this.claimed + index + 1}` });
    });

    this.claimed += stages.length;
    this.mission.onChanged();

    this.mission.updateMissionIcon();

    return stages.reduce((total, stage) => RewardsList.sumRewards(total, stage.prize), {});
};

RoyalLeagueLogic.prototype.beforeRemove = function (f) {
    const stagePrize = this.claimStages();
    if (!stagePrize) {
        f();
        return;
    }

    Mission.createRewardWindow(stagePrize, this.mission);
    cleverapps.focusManager.onceNoWindowsListener = f;
};

RoyalLeagueLogic.prototype.isAttentionRequired = function () {
    return this.hasUnclaimedStages() || (this.mission.runningCompetition && this.mission.runningCompetition.hasPlaceChanged());
};

RoyalLeagueLogic.Starter = function (type) {
    if (!cleverapps.user.isPassedAllPhysicalLevels() || !cleverapps.missionManager.canCreateType(type)) {
        return false;
    }

    if (!Missions[type].schedule) {
        return true;
    }

    const { startDate, endDate } = MissionManager.parseWeekdayRange(Missions[type].schedule);
    if (Date.now() < startDate.getTime() || Date.now() >= endDate.getTime()) {
        return false;
    }

    return cleverapps.missionManager.getLastRemoved(type) < endDate.getTime();
};

RoyalLeagueLogic.CalcTier = function (points) {
    return RoyalLeagueLogic.TIERS.filter((threshold) => points >= threshold).length;
};

RoyalLeagueLogic.TIERS = [200, 1500];
RoyalLeagueLogic.TIER_NAMES = ["gold", "emerald", "diamond"];
